import React from 'react';
import PropTypes from 'prop-types';
import { A } from '../../../hybrid/wrappers';
import classNames from 'classnames';

const Title = ({ body, links, Comp, data, linkData }) => {
    const elemProps = data ? { ...data } : {};

    if (links && Object.keys(links).length) {
        const linksProps = linkData || {};
        const linksJsx = Object.keys(links).reduce((accum, linkKey) => {
            const linkObj = links[linkKey];
            accum[linkKey] = (
                <A
                    key={`titleLink${linkKey}`}
                    {...linksProps}
                    className={classNames('activeLink', linksProps?.className)}
                    href={linkObj.href}
                    target={linkObj.target}
                >
                    {linkObj.title}
                </A>
            );
            return accum;
        }, {});
        return (
            <Comp {...elemProps}>
                {body.split('${').reduce((arr, part, idx) => {
                    if (idx === 0) {
                        arr.push(<React.Fragment key={`title${idx}`}>{part}</React.Fragment>);
                        return arr;
                    }
                    const splitPart = part.split('}');
                    const text = splitPart.slice(1).join('}');
                    arr.push(<React.Fragment key={`title${idx}var`}>{linksJsx[splitPart[0]]}</React.Fragment>);
                    arr.push(<React.Fragment key={`title${idx}text`}>{text}</React.Fragment>);
                    return arr;
                }, [])}
            </Comp>
        );
    }
    return <Comp {...elemProps}>{body}</Comp>;
};
Title.propTypes = {
    body: PropTypes.node,
    links: PropTypes.object,
    data: PropTypes.object,
    linkData: PropTypes.object
};
export default Title;
